import { useContext } from 'react'
import { AppDispatch } from './Model'
import restaurantFrontDoor from './assets/restaurant-front-door.webp'
import food from './assets/food.webp'
import staff from './assets/staff.webp'
import parties from './assets/parties.webp'

export default function Galleries() {
	return (
		<div className='galleries'>
			<CastelloGallery />
			<div className='grid'>
				<FoodGallery />
				<StaffGallery />
				<PartiesGallery />
			</div>
		</div>
	)
}

function CastelloGallery() {
	const dispatch = useContext(AppDispatch)

	return (
		<div className='montage'>
			<img src={restaurantFrontDoor} alt='Edit this component in /src/Layout.js' />
			<div className='overlay'>
				<button onClick={() => dispatch({ type: 'gallery', value: 'castello' })}>View Main Castello Gallery</button>
			</div>
		</div>
	)
}

function FoodGallery() {
	const dispatch = useContext(AppDispatch)

	return (
		<div className='montage'>
			<img src={food} alt='Edit this component in /src/Layout.js' />
			<div className='overlay'>
				<button onClick={() => dispatch({ type: 'gallery', value: 'food' })}>Food Gallery</button>
			</div>
		</div>
	)
}

function StaffGallery() {
	const dispatch = useContext(AppDispatch)

	return (
		<div className='montage'>
			<img src={staff} alt='Edit this component in /src/Layout.js' />
			<div className='overlay'>
				<button onClick={() => dispatch({ type: 'gallery', value: 'staff' })}>Staff Gallery</button>
			</div>
		</div>
	)
}

function PartiesGallery() {
	const dispatch = useContext(AppDispatch)

	return (
		<div className='montage'>
			<img src={parties} alt='Edit this component in /src/Layout.js' />
			<div className='overlay'>
				<button onClick={() => dispatch({ type: 'gallery', value: 'parties' })}>Parties Gallery</button>
			</div>
		</div>
	)
}
